import { createContext, useContext, useMemo } from 'react';
import type { ReactNode } from 'react';

import { createTheme, defaultTheme } from './tokens';
import type { ThemeColors, ThemeFontFamily, ThemeTokens } from './tokens';

const ThemeContext = createContext<ThemeTokens>(defaultTheme);

export interface ThemeProviderProps {
  primaryColor?: string;
  colors?: Partial<ThemeColors>;
  fontFamily?: ThemeFontFamily;
  children: ReactNode;
}

export function ThemeProvider({ primaryColor, colors, fontFamily, children }: ThemeProviderProps) {
  const theme = useMemo(
    () => createTheme({ primary: primaryColor, colors, fontFamily }),
    [primaryColor, colors, fontFamily],
  );

  return <ThemeContext.Provider value={theme}>{children}</ThemeContext.Provider>;
}

export function useTheme(): ThemeTokens {
  return useContext(ThemeContext);
}
